import React from 'react';
import VoipPage from '../components/voip/VoipPage';

const VoipPageWrapper = () => {
  return <VoipPage />;
};

export default VoipPageWrapper;
